﻿import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import { Circle as CircleStyle, Icon, Fill, Stroke, Style, Text } from 'ol/style.js';
export { WaterWaste };

/**
 * Class Water Waste
 */
const WaterWaste = function () {

    //Define this
    var myWaterWaste = this;

    // -- begin public variable -------------------------------------------------------------------

    // Datatable water waste element
    this.datatableWaterWasteElement = null;

    // Datatable water waste statistic
    this.datatableWaterWasteStatistic = null;

    // -- end public variable ---------------------------------------------------------------------

    // -- begin private variable ------------------------------------------------------------------

    // Map
    this._mapSgs = null;

    // Chekbox analysis active visible obj
    this._analisysCheckbox = null;

    // Style for layer go to
    // Style for selected layer vector
    this._styleGoto = [
        new Style({
            image: new CircleStyle({
                radius: 10,
                stroke: new Stroke({
                    color: '#ffff00',
                    width: 5
                }),
                fill: new Fill({
                    color: 'rgba(0, 0, 255, 0.2)'
                })
            }),
            stroke: new Stroke({
                color: '#ffff00',
                width: 14
            }),
            fill: new Fill({
                color: 'rgba(0, 0, 255, 0.5)'
            })
        })
    ];

    // Define source layer go to
    this._sourceGoto = new VectorSource();

    // Layer for go to
    this._layerGoto = new VectorLayer(
        {
            source: myWaterWaste._sourceGoto,
            id: 'water_waste'
        });

    // -- end private variable --------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    /**
     * Init water waste
     * @param {MapSgs} mapSgs, Map sgs class
     */
    this.Init = function (mapSgs) {





    };

    /**
     * Pipe up stream analysis
     */
    this.UpStreamAnalysis = function () {
        // Check if any pipe is selected
        if (app.Select.getFeatures().getLength() === 0 ||
            (
                app.Select.getFeatures().getLength() > 0 &&
                !(app.Select.getFeatures().getArray()[0].getId().split(".")[0] === 'vw_ww_pipe_line_1') &&
                !(app.Select.getFeatures().getArray()[0].getId().split(".")[0] === 'vw_ww_out_pipe_line_1')
            )
        ) {
            toastr["warning"]("Escolha primeiro um colector ou uma conduta emissário");
            return;
        }

        // ShowWait
        myMapSgs._utility.ShowWait('offcanvas-map-spinner', true);

        // Get id pipe
        var idPipe = app.Select.getFeatures().getArray()[0].getId().split(".")[1];

        // Get pipe type
        var pipeType = "";
        var layerNamePipe = "";
        var layerNameManhole = "";
        var columPipeTypeValue = "";
        var columManholeTypeValue = "";
        switch (app.Select.getFeatures().getArray()[0].getId().split('.')[0]) {
            case "vw_ww_pipe_line_1":
                pipeType = "ww_pipe";
                layerNamePipe = "vw_ww_pipe_line_1";
                layerNameManhole = "vw_ww_manhole_point_1";
                columPipeTypeValue = "Colector";
                columManholeTypeValue = "Caixa de visita";
                break;
            case "vw_ww_out_pipe_line_1":
                pipeType = "ww_out_pipe";
                layerNamePipe = "vw_ww_out_pipe_line_1";
                layerNameManhole = "vw_ww_out_manhole_point_1";
                columPipeTypeValue = "Conduta emissário";
                columManholeTypeValue = "Caixa de visita emissário";
                break;
            default:
            // do nothing
        }

        // Get idSystem
        var idSystem = 1; // Temp, get sistem pipe

        // Clean high light
        //if (myMapSgs.featureToHighLight.getLength() > 0) myMapSgs.featureToHighLight.clear();
        myMapSgs.tryClearFeatures();

        // Clean table
        myMapSgs._waterWaste.datatableWaterWasteElement.clear().draw();
        myMapSgs._waterWaste.datatableWaterWasteStatistic.clear().draw();

        // Call UpStream analysis
        $.ajax({
            type: 'GET',
            url: '/rest/app/WaterWaste/GetPipeUpStream?idSystem=' + idSystem + '&idPipe=' + idPipe + '&pipeType=' + pipeType,
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na identificação da rede a montante");
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            // -- Pipe selected --
                            var stylePipeSelected = [
                                new Style({
                                    image: new CircleStyle({
                                        radius: 4,
                                        stroke: new Stroke({
                                            color: 'yellow',
                                            width: 2
                                        }),
                                        fill: new Fill({
                                            color: 'rgba(255, 255, 0, 0.5)'
                                        })
                                    }),
                                    stroke: new Stroke({
                                        color: 'rgba(70,130,180,0.5)',
                                        width: 2
                                    }),
                                    fill: new Fill({
                                        color: 'rgba(255, 255, 0, 0)'
                                    })
                                    ,
                                    text: new Text({
                                        text: '',
                                        font: 'normal 14px Arial',
                                        textBaseline: 'Middle',
                                        offsetY: -10,
                                        backgroundFill: new Fill({ color: 'white' }),
                                        fill: new Fill({
                                            color: 'rgba(0, 0, 0, 1)'
                                        }),
                                        stroke: new Stroke({
                                            color: 'rgba(255, 255, 200, 1)',
                                            width: 8
                                        })
                                    })
                                }),
                                new Style({
                                    stroke: new Stroke({
                                        color: 'rgba(255, 255, 0, 0.5)',
                                        width: 5
                                    }),
                                    fill: new Fill({
                                        color: 'rgba(255, 255, 0, 0)'
                                    })
                                })
                            ];
                            var arrayIdPipeSelected = [idPipe];
                            var gpSource = app.sgs.Map.getSettings()._mapSettings.search_toponymy.workspaceSearchToponymy == 'GP_MEALHADA' ? 'GP_MEALHADA' : 'GP';
                            myMapSgs.SetFeaturesHighlightByArray(gpSource, layerNamePipe, true, arrayIdPipeSelected, stylePipeSelected);

                            // -- Pipes --
                            var stylePipes = [
                                new Style({
                                    image: new CircleStyle({
                                        radius: 4,
                                        stroke: new Stroke({
                                            color: 'rgba(255,255,0,1)',
                                            width: 10
                                        }),
                                        fill: new Fill({
                                            color: 'rgba(70,130,180,0.2)'
                                        })
                                    }),
                                    stroke: new Stroke({
                                        color: 'rgba(70,130,180,0.5)',
                                        width: 2
                                    }),
                                    fill: new Fill({
                                        color: 'rgba(255, 255, 0, 0)'
                                    })
                                    ,
                                    text: new Text({
                                        text: '',
                                        font: 'normal 14px Arial',
                                        textBaseline: 'Middle',
                                        offsetY: -10,
                                        backgroundFill: new Fill({ color: 'white' }),
                                        fill: new Fill({
                                            color: 'rgba(0, 0, 0, 1)'
                                        }),
                                        stroke: new Stroke({
                                            color: 'rgba(255, 255, 200, 1)',
                                            width: 8
                                        })
                                    })
                                }),
                                new Style({
                                    stroke: new Stroke({
                                        color: 'rgba(255, 0, 0, 0.5)',
                                        width: 5
                                    }),
                                    fill: new Fill({
                                        color: 'rgba(255, 255, 0, 0)'
                                    })
                                })
                            ];
                            var arrayIds = [];
                            var idPipeUpStream;
                            for (let i = 0; i < data.result.list_ww_pipe_upstream_analysis.length; i++) {
                                idPipeUpStream = data.result.list_ww_pipe_upstream_analysis[i].id_pipe;
                                if (idPipeUpStream != idPipe)
                                    arrayIds.push(idPipeUpStream);
                            }
                            if (arrayIds.length > 0)
                                myMapSgs.SetFeaturesHighlightByArray(gpSource, layerNamePipe, true, arrayIds, stylePipes);
                            // Put in table
                            for (let i = 0; i < data.result.list_pipe.length; i++) {
                                var pipeObj = data.result.list_pipe[i];
                                myMapSgs._waterWaste.datatableWaterWasteElement.row.add({
                                    id: pipeObj.id,
                                    workspace: gpSource,
                                    layer_name: layerNamePipe,
                                    code: pipeObj.code,
                                    element_type: columPipeTypeValue
                                });
                            }

                            // -- Manhole --
                            var styleManhole = [
                                new Style({
                                    image: new CircleStyle({
                                        radius: 10,
                                        stroke: new Stroke({
                                            color: 'rgba(0, 0, 255, 0.2)',
                                            width: 5
                                        }),
                                        fill: new Fill({
                                            color: 'rgba(0, 0, 255, 0.2)'
                                        })
                                    }),
                                    stroke: new Stroke({
                                        color: 'rgba(0, 0, 255, 0.2)',
                                        width: 14
                                    }),
                                    fill: new Fill({
                                        color: 'rgba(0, 0, 255, 0.5)'
                                    })
                                })
                            ];
                            arrayIds = [];
                            for (let i = 0; i < data.result.list_manhole.length; i++) {
                                var manholeObj = data.result.list_manhole[i];
                                arrayIds.push(manholeObj.id_manhole);

                                // Put in table
                                myMapSgs._waterWaste.datatableWaterWasteElement.row.add({
                                    id: manholeObj.id_manhole,
                                    workspace: gpSource,
                                    layer_name: layerNameManhole,
                                    code: manholeObj.code,
                                    element_type: columManholeTypeValue
                                });
                            }
                            if (arrayIds.length > 0)
                                myMapSgs.SetFeaturesHighlightByArray(gpSource, layerNameManhole, true, arrayIds, styleManhole);

                            // -- Service pipes --
                            var styleServicePipes = [
                                new Style({
                                    stroke: new Stroke({
                                        color: 'rgba(70,130,180,0.5)',
                                        width: 2
                                    }),
                                    fill: new Fill({
                                        color: 'rgba(255, 255, 0, 0)'
                                    })
                                    ,
                                    text: new Text({
                                        text: '',
                                        font: 'normal 14px Arial',
                                        textBaseline: 'Middle',
                                        offsetY: -10,
                                        backgroundFill: new Fill({ color: 'white' }),
                                        fill: new Fill({
                                            color: 'rgba(0, 0, 0, 1)'
                                        }),
                                        stroke: new Stroke({
                                            color: 'rgba(255, 255, 200, 1)',
                                            width: 8
                                        })
                                    })
                                }),
                                new Style({
                                    stroke: new Stroke({
                                        color: 'rgba(255, 100, 0, 0.5)',
                                        width: 5
                                    }),
                                    fill: new Fill({
                                        color: 'rgba(255, 255, 0, 0)'
                                    })
                                })
                            ];
                            arrayIds = [];
                            for (let i = 0; i < data.result.list_service_pipe.length; i++) {
                                var pipeServiceObj = data.result.list_service_pipe[i];
                                arrayIds.push(pipeServiceObj.id_service_pipe);

                                // Put in table
                                myMapSgs._waterWaste.datatableWaterWasteElement.row.add({
                                    id: pipeServiceObj.id_service_pipe,
                                    workspace: gpSource,
                                    layer_name: 'vw_ww_service_conn_pipe_line_1',
                                    code: pipeServiceObj.code,
                                    element_type: 'Ramal'
                                });
                            }
                            if (arrayIds.length > 0)
                                myMapSgs.SetFeaturesHighlightByArray(gpSource, 'vw_ww_service_conn_pipe_line_1', true, arrayIds, styleServicePipes);

                            // Refreh table
                            myMapSgs._waterWaste.datatableWaterWasteElement.draw();

                            // Fill statistic
                            for (let i = 0; i < data.result.list_statistic.length; i++) {
                                var statisticObj = data.result.list_statistic[i];

                                // Put in table
                                myMapSgs._waterWaste.datatableWaterWasteStatistic.row.add({
                                    cod_type: statisticObj.cod_type,
                                    type_description: statisticObj.type_description,
                                    cod_value: statisticObj.cod_value,
                                    value_description: statisticObj.value_description,
                                    value: statisticObj.value
                                });
                            }

                            // Refreh table
                            myMapSgs._waterWaste.datatableWaterWasteStatistic.draw();

                            // Alter title of map list
                            $('#offcanvas-map-list-title')[0].innerHTML = "Análise Montante Nº" + data.result.id_analysis;

                            // Alter title extend go
                            //$('#offcanvas-search-event-layer-visible-title')[0].innerHTML = "Enquadrar dos elementos da análise";

                            // Clear select element
                            app.Select.getFeatures().clear();

                            toastr["success"]("Sucesso na identificação da rede a montante");
                            break;
                        default:
                            toastr["error"]("Erro na identificação da rede a montante");
                    }
                }
                // ShowWait
                myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na identificação da rede a montante");
                // ShowWait
                myMapSgs._utility.ShowWait('offcanvas-map-spinner', false);
            }
        });
    }

    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------

    // -- end private method ----------------------------------------------------------------------

    // -- begin event -----------------------------------------------------------------------------

    /**
     * Event checkbox change view analysis in map
     */
    $('#offcanvas-search-event-layer-visible').on('change', function () {
        if (myWaterWaste._mapSgs.layerHighlightOverlay.getSource().getFeatures().length > 0) {
            if (myWaterWaste._analisysCheckbox.state() === 'checked') {
                myWaterWaste._mapSgs.layerHighlightOverlay.setVisible(true);
            }
            else {
                myWaterWaste._mapSgs.layerHighlightOverlay.setVisible(false);
            }
            myWaterWaste._mapSgs.map.renderSync();
        }
    });

    /**
     * Event goto analysis in map 
     */
    $('#offcanvas-search-event-layer-goto').on('click', function () {
        myWaterWaste._mapSgs.map.getView().fit(myWaterWaste._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myWaterWaste._mapSgs.map.getSize() });
    });

    // -- end event -------------------------------------------------------------------------------

};

/**
* Init citizen report
* @param {object} mapSgs, map object
*/
WaterWaste.prototype.Init = function (mapSgs) {

    // Set map info
    this._mapSgs = mapSgs;


    // -- Add layer goto to map ---------------------------------------------------------------
    this._mapSgs.map.addLayer(myWaterWaste._layerGoto);

    // -- Init checkbox show analysis ---------------------------------------------------------
    //this._analisysCheckbox = $('#offcanvas-search-event-layer-visible').checkbox().state('checked');

    // -- Init table element found ------------------------------------------------------------

    // -- init column def --
    var columnDefArray = [];

    // Goto button
    var objDef =
    {
        'name': 'button_config_element',
        'data': null,
        'orderable': false,
        'className': 'dt-body-center',
        'defaultContent': '<a class="button-goto-water-waste" title="Ir para a posição do elemento"><i class="zmdi zmdi-gps-dot" style="color: #ff3d00"></i></a>',
        'width': '20px'
    };
    columnDefArray.push(objDef);
    // Go to detail
    objDef =
    {
        'name': 'button_config_element',
        'data': null,
        'orderable': false,
        'className': 'dt-body-center',
        'defaultContent': '<a class="button-detail-water-waste" title="Ir para o detalhe do elemento"><i class="gpi gpi-info" style="color: #ff3d00"></i></a>',
        'width': '20px'
    };
    columnDefArray.push(objDef);
    // id
    objDef = {
        'data': 'id',
        'title': 'Id',
        'name': 'Id',
        'label': 'Id',
        'type': 'readonly',
        'visible': false
    };
    columnDefArray.push(objDef);
    // workspace
    objDef = {
        'data': 'workspace',
        'title': 'workspace',
        'name': 'workspace',
        'label': 'workspace',
        'type': 'readonly',
        'visible': false
    };
    columnDefArray.push(objDef);
    // layer name
    objDef = {
        'data': 'layer_name',
        'title': 'layer_name',
        'name': 'layer_name',
        'label': 'layer_name',
        'type': 'readonly',
        'visible': false
    };
    columnDefArray.push(objDef);
    // code
    objDef = {
        'data': 'code',
        'title': 'Código',
        'name': 'Código',
        'label': 'Código',
        'type': 'readonly',
        'orderable': false,
        'width': '200px'
    };
    columnDefArray.push(objDef);
    // Tipo de elemento
    objDef = {
        'data': 'element_type',
        'title': 'Tipo',
        'name': 'Tipo',
        'label': 'Tipo',
        'type': 'readonly',
        'orderable': false,
        'width': '150px'
    };
    columnDefArray.push(objDef);

    // -- Table definition --
    myWaterWaste.datatableWaterWasteElement = $('#offcanvas-map-list-search-result-table').DataTable({
        "dom": '<"top"ifp>rt',
        "destroy": true,
        "language": {
            "emptyTable": 'Nenhum elemento encontrado',
            "search": "Filtro"
        },
        "fixedHeader": false,
        "info": false,
        "scrollY": $('#offcanvas-map-list-search-result-table-zone').height() - 80,
        "scrollX": true,
        "scrollCollapse": false,
        "deferRender": false,
        "scroller": false,
        "paging": true,
        "ordering": false,
        "columns": columnDefArray,
        "select": false,
        "name": "search_event_result",
        "rowId": 'id'
    });

    // Event draw table search occurrence
    myWaterWaste.datatableWaterWasteElement.on('draw', function () {

        // Event goto water detail
        $('.button-detail-water-waste').on('click', function () {
            // Get id element
            var id = $(this).parent().parent()[0].id;



            // Set Detail occurrence
            //myOccurrences._DetailOccurrence(id);
        });

        // Event goto occurrence search in map 
        $('.button-goto-water-waste').on('click', function () {
            // Get id element
            var id = $(this).parent().parent()[0].id;

            var workspace = myWaterWaste.datatableWaterWasteElement.row('#' + id).data().workspace;
            var layer_name = myWaterWaste.datatableWaterWasteElement.row('#' + id).data().layer_name;

            // Clean layer goto
            myWaterWaste._sourceGoto.clear();

            // Goto layer
            myWaterWaste._mapSgs.SetFeaturesAnyHighlightByArray(workspace, layer_name, true, [id], myWaterWaste._layerGoto, myWaterWaste._sourceGoto, myWaterWaste._styleGoto);
        });
    });

    // -- Init table statistics ---------------------------------------------------------------

    // -- init column def --
    columnDefArray = [];

    // cod_type
    objDef = {
        'data': 'cod_type',
        'title': 'cod_type',
        'name': 'cod_type',
        'label': 'cod_type',
        'type': 'readonly',
        'visible': false
    };
    columnDefArray.push(objDef);
    // type_description
    objDef = {
        'data': 'type_description',
        'title': 'Tipo',
        'name': 'Tipo',
        'label': 'Tipo',
        'type': 'readonly',
        'orderable': false,
        'width': '30px'
    };
    columnDefArray.push(objDef);
    // cod_type
    objDef = {
        'data': 'cod_value',
        'title': 'cod_value',
        'name': 'cod_value',
        'label': 'cod_value',
        'type': 'readonly',
        'visible': false
    };
    columnDefArray.push(objDef);
    // value_description
    objDef = {
        'data': 'value_description',
        'title': 'Indicador',
        'name': 'Indicador',
        'label': 'Indicador',
        'type': 'readonly',
        'orderable': false,
        'width': '30px'
    };
    columnDefArray.push(objDef);
    // value
    objDef = {
        'data': 'value',
        'title': 'Valor',
        'name': 'Valor',
        'label': 'Valor',
        'type': 'readonly',
        'orderable': false,
        'width': '30px'
    };
    columnDefArray.push(objDef);

    // -- Table definition --
    myWaterWaste.datatableWaterWasteStatistic = $('#offcanvas-water-waste-statistic-table').DataTable({
        "dom": 'rtip', //'<r>ftip',
        "destroy": true,
        "language": {
            "emptyTable": 'Nenhum elemento encontrado',
            "search": "Filtro"
        },
        "fixedHeader": true,
        "info": false,
        "scrollCollapse": false,
        "deferRender": false,
        "scroller": false,
        "paging": true,
        "ordering": false,
        "columns": columnDefArray,
        "searching": false,
        "select": false,
        "name": "search_event_result",
        "rowId": 'id'
    });
};